import React, { useState, useEffect } from "react";
import "./AgentFeedbackModal.css";
import {
  getAgentFeedbackAPI,
  postAgentFeedbackAPI,
} from "../../../../src/operations/services/getAgentPortal.js";
import { formatDateTimeEST } from "../../Helper/checkCondition";
import { useSelector, useDispatch } from "react-redux";
import { showFeedbackModal } from "../../../../src/redux/slices/notificationSlice";

// const formatDateTimeEST = (dateStr) => {
//   if (!dateStr) return "N/A";

//   return new Date(dateStr).toLocaleString("en-US", {
//     timeZone: "America/New_York", // ✅ THIS FIX
//     month: "2-digit",
//     day: "2-digit",
//     year: "numeric",
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   });
// };

const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length >= 2)
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return (parts[0]?.[0] || "?").toUpperCase();
};

const getAvatarColor = (name) => {
  const colors = [
    "#1b3d5f",
    "#2d7d9a",
    "#e67e22",
    "#27ae60",
    "#8e44ad",
    "#c0392b",
    "#16a085",
    "#2980b9",
    "#d35400",
    "#6c5ce7",
  ];
  if (!name) return colors[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash += name.charCodeAt(i);
  return colors[hash % colors.length];
};

const AgentFeedbackModal = ({ isOpen, onClose, selectedAgent }) => {
  const [responseExpectation, setResponseExpectation] = useState("yes");
  const [feedback, setFeedback] = useState("");
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [replyOpenId, setReplyOpenId] = useState(null);
  const [replyTexts, setReplyTexts] = useState({});
  const [expandedThreads, setExpandedThreads] = useState({});
  const [savingFeedback, setSavingFeedback] = useState(false);
  const [sendingReplyId, setSendingReplyId] = useState(null);
  const [userRole, setUserRole] = useState("");

  const dispatch = useDispatch();

  const showModalBasedOnNotification = useSelector(
    (state) => state.notifications.notificationNavigation.showFeedbackModal,
  );

  const handleModalClose = () => {
    // Reset feedback and call the original onClose
    setFeedback("");
    dispatch(showFeedbackModal(false));
    onClose();
  };

  useEffect(() => {
    console.log(
      "showModalBasedOnNotification ==> ",
      !isOpen,
      !showModalBasedOnNotification,
    );

    if (!isOpen && !showModalBasedOnNotification) {
      setFeedback("");
      return;
    }

    const fetchFeedbackData = async () => {
      try {
        setLoading(true);
        setError(null);

        const loginState = localStorage.getItem("loginState");
        if (!loginState) {
          console.warn("Login state not found in localStorage.");
          setHistoryData([]);
          setLoading(false);
          return;
        }

        const loginData = JSON.parse(loginState);
        const userData = loginData?.data?.[0];
        console.log(userData,"userData")
        const userId = userData?.AdminID;
        setUserRole(userData?.Role || "Unknown");
        console.log("userId ==> ", userId);

        if (!userId) {
          console.warn("User ID not found in login state.");
          setHistoryData([]);
          setLoading(false);
          return;
        }

        console.log("RRRRRRRRRRRRRRRRRRRRRRRRR");

        // For non-Agent roles, get the agent ID from selectedAgent
        const agentId =
          userData?.Role != "Agent" && selectedAgent
            ? selectedAgent.value.replace(/\D/g, "")
            : null;

        const response = await getAgentFeedbackAPI(userId, agentId);
        console.log("Fetched feedback data:", response);

        // Check if response is an array of threads (nested structure)
        if (!response || !Array.isArray(response)) {
          console.warn("Invalid response from feedback API.");
          setHistoryData([]);
          setLoading(false);
          return;
        }

        const transformedData = response.map((item) => ({
          feedbackId: item.FeedbackId,
          threadId: item.ThreadId,
          createdAt: item.CreatedAt,
          date: formatDateTimeEST(item.CreatedAt),
          senderName: item.SenderName
            ? item.SenderName.replace(/\bnull\b/gi, "").trim()
            : "Unknown",
          senderUserId: item.SenderUserId,
          receiverUserId: item.ReceiverUserId,
          messageText: item.MessageText,
          isResponseExpected: item.IsResponseExpected,
          senderRole: item.SenderRole || "Unknown",
          isActive: item.IsActive === "Y",
          parentFeedbackId: item.ParentFeedbackId,
        }));

        setHistoryData(transformedData);
      } catch (err) {
        console.error("Error fetching feedback data:", err);
        setError(err.message || "Failed to fetch feedback data.");
        setHistoryData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedbackData();
  }, [isOpen, showModalBasedOnNotification, selectedAgent]);

  const handleReplyClick = (feedbackId) => {
    setReplyOpenId(replyOpenId === feedbackId ? null : feedbackId);
  };

  const handleReplyTextChange = (feedbackId, text) => {
    setReplyTexts((prev) => ({
      ...prev,
      [feedbackId]: text,
    }));
  };

  const handleThreadToggle = (threadId) => {
    setExpandedThreads((prev) => ({
      ...prev,
      [threadId]: !prev[threadId],
    }));
  };

  const getSenderInfo = () => {
    try {
      const loginState = localStorage.getItem("loginState");
      if (!loginState) {
        console.warn("Login state not found in localStorage.");
        return null;
      }

      const loginData = JSON.parse(loginState);
      const userData = loginData?.data?.[0];

      if (!userData) {
        console.warn("User data not found in login state.");
        return null;
      }

      return {
        senderUserId: userData.AdminID,
        senderName: `${userData.FirstName} ${userData.LastName}`
          .replace(/\bnull\b/gi, "")
          .trim(),
        senderRole: userData.Role,
      };
    } catch (err) {
      console.error("Error extracting sender info:", err);
      return null;
    }
  };

  const extractAgentId = (agentValue) => {
    if (!agentValue) return null;
    return agentValue.replace(/^A/, "");
  };

  const refreshFeedbackData = async () => {
    try {
      const loginState = localStorage.getItem("loginState");
      if (!loginState) return;

      const loginData = JSON.parse(loginState);
      const userId = loginData?.data?.[0]?.AdminID;

      if (userId) {
        const agentId =
          userRole != "Agent" && selectedAgent
            ? selectedAgent.value.replace(/\D/g, "")
            : null;
        const response = await getAgentFeedbackAPI(userId, agentId);
        if (response && Array.isArray(response)) {
          // Transform the nested thread structure into flat array of messages
          const transformedData = [];

          response.forEach((thread) => {
            if (thread.messages && Array.isArray(thread.messages)) {
              thread.messages.forEach((message) => {
                transformedData.push({
                  feedbackId: message.FeedbackId,
                  threadId: message.ThreadId,
                  createdAt: message.CreatedAt,
                  date: formatDateTimeEST(message.CreatedAt),
                  senderName: message.SenderName
                    ? message.SenderName.replace(/\bnull\b/gi, "").trim()
                    : "Unknown",
                  senderUserId: message.SenderUserId,
                  receiverUserId: message.ReceiverUserId,
                  messageText: message.MessageText,
                  isResponseExpected: message.IsResponseExpected,
                  senderRole: message.SenderRole || "Unknown",
                  isActive: message.IsActive === "Y",
                  parentFeedbackId: message.ParentFeedbackId,
                });
              });
            }
          });

          setHistoryData(transformedData);
        }
      }
    } catch (err) {
      console.error("Error refreshing feedback data:", err);
    }
  };

  const handleSendReply = async (feedbackId) => {
    const replyText = replyTexts[feedbackId];
    if (!replyText || replyText.trim() === "") {
      console.warn("Reply text is empty");
      return;
    }

    try {
      setSendingReplyId(feedbackId);
      const senderInfo = getSenderInfo();
      if (!senderInfo) {
        console.error("Unable to get sender info");
        setSendingReplyId(null);
        return;
      }

      const feedbackItem = historyData.find(
        (item) => item.feedbackId === feedbackId,
      );

      console.log("Feedback item: ==> ", feedbackItem, senderInfo);

      if (!feedbackItem) {
        console.error("Feedback item not found");
        setSendingReplyId(null);
        return;
      }

      const payload = {
        senderUserId: senderInfo.senderUserId,
        receiverUserId:
          userRole == "Agent"
            ? feedbackItem.senderUserId
            : feedbackItem.receiverUserId,
        messageText: replyText.trim(),
        senderName: senderInfo.senderName,
        senderRole: senderInfo.senderRole,
        isResponseExpected: false,
        parentFeedbackId: feedbackId,
        threadId: feedbackItem.threadId,
      };

      console.log("Sending reply payload:", payload);

      await postAgentFeedbackAPI(payload);

      setReplyTexts((prev) => ({
        ...prev,
        [feedbackId]: "",
      }));
      setReplyOpenId(null);

      const loginState = localStorage.getItem("loginState");
      const loginData = JSON.parse(loginState);
      const userId = loginData?.data?.[0]?.AdminID;
      if (userId) {
        const agentId =
          userRole != "Agent" && selectedAgent
            ? selectedAgent.value.replace(/\D/g, "")
            : null;
        const response = await getAgentFeedbackAPI(userId, agentId);
        if (response && Array.isArray(response)) {
          const transformedData = response.map((item) => ({
            feedbackId: item.FeedbackId,
            threadId: item.ThreadId,
            createdAt: item.CreatedAt,
            date: formatDateTimeEST(item.CreatedAt),
            senderName: item.SenderName || "Unknown",
            senderUserId: item.SenderUserId,
            receiverUserId: item.ReceiverUserId,
            messageText: item.MessageText,
            isResponseExpected: item.IsResponseExpected,
            senderRole: item.SenderRole || "Unknown",
            isActive: item.IsActive === "Y",
            parentFeedbackId: item.ParentFeedbackId,
          }));
          setHistoryData(transformedData);
        }
      }
    } catch (err) {
      console.error("Error sending reply:", err);
    } finally {
      setSendingReplyId(null);
    }
  };

  const organizeByThread = () => {
    const threadMap = {};

    historyData.forEach((item) => {
      if (!threadMap[item.threadId]) {
        threadMap[item.threadId] = {
          parentMessage: null,
          replies: [],
        };
      }

      if (item.parentFeedbackId === null) {
        threadMap[item.threadId].parentMessage = item;
      } else {
        threadMap[item.threadId].replies.push(item);
      }
    });

    const threads = Object.entries(threadMap).map(([threadId, data]) => ({
      threadId: parseInt(threadId),
      parentMessage: data.parentMessage,
      replies: data.replies.sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      ),
    }));

    threads.sort((a, b) => {
      const aLatest = a.replies.length
        ? new Date(a.replies[a.replies.length - 1].createdAt).getTime()
        : new Date(a.parentMessage?.createdAt || 0).getTime();
      const bLatest = b.replies.length
        ? new Date(b.replies[b.replies.length - 1].createdAt).getTime()
        : new Date(b.parentMessage?.createdAt || 0).getTime();
      return bLatest - aLatest;
    });

    return threads;
  };

  const threads = organizeByThread();

  const renderThread = (thread) => {
    const { threadId, parentMessage, replies } = thread;
    const isExpanded = expandedThreads[threadId] !== false;

    if (!parentMessage) return null;

    const cleanName = (name) =>
      name ? name.replace(/\bnull\b/gi, "").trim() : "Unknown";

    const parentName = cleanName(parentMessage.senderName);

    return (
      <div key={`thread-${threadId}`} className="yt-thread">
        {/* Parent comment */}
        <div className="yt-comment">
          <div className="yt-comment-body">
            <div className="yt-comment-meta">
              <span className="yt-author">{parentName}</span>
              <span className="yt-role-badge">{parentMessage.senderRole}</span>
              <span className="yt-dot">·</span>
              <span className="yt-timestamp">{parentMessage.date}</span>
            </div>

            <p className="yt-comment-text">{parentMessage.messageText}</p>

            <div className="yt-comment-actions">
              {parentMessage.isResponseExpected && (
                <span className="yt-response-badge">Response Expected</span>
              )}
              {parentMessage.isResponseExpected && (
                <button
                  className="yt-reply-btn"
                  onClick={() => handleReplyClick(parentMessage.feedbackId)}
                >
                  {replyOpenId === parentMessage.feedbackId
                    ? "Cancel"
                    : "Reply"}
                </button>
              )}
            </div>

            {replyOpenId === parentMessage.feedbackId && (
              <div className="yt-reply-compose">
                <div className="yt-compose-inner">
                  <textarea
                    className="yt-compose-input"
                    placeholder="Add a reply..."
                    value={replyTexts[parentMessage.feedbackId] || ""}
                    onChange={(e) =>
                      handleReplyTextChange(
                        parentMessage.feedbackId,
                        e.target.value,
                      )
                    }
                    disabled={sendingReplyId === parentMessage.feedbackId}
                  />
                  <div className="yt-compose-actions">
                    <button
                      className="yt-compose-cancel"
                      onClick={() => handleReplyClick(parentMessage.feedbackId)}
                    >
                      Cancel
                    </button>
                    <button
                      className="yt-compose-send"
                      onClick={() => handleSendReply(parentMessage.feedbackId)}
                      disabled={
                        sendingReplyId === parentMessage.feedbackId ||
                        !replyTexts[parentMessage.feedbackId]?.trim()
                      }
                    >
                      {sendingReplyId === parentMessage.feedbackId ? (
                        <>
                          <span className="crs-loader"></span>Sending...
                        </>
                      ) : (
                        "Reply"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Replies toggle */}
        {replies.length > 0 && (
          <div className="yt-replies-section">
            <button
              className="yt-replies-toggle"
              onClick={() => handleThreadToggle(threadId)}
            >
              <span className={`yt-chevron ${isExpanded ? "expanded" : ""}`}>
                ▼
              </span>
              {replies.length} {replies.length === 1 ? "reply" : "replies"}
            </button>

            {isExpanded && (
              <div className="yt-replies-list">
                {replies.map((reply) => {
                  const replyName = cleanName(reply.senderName);
                  return (
                    <div
                      key={`reply-${reply.feedbackId}`}
                      className="yt-comment yt-comment--reply"
                    >
                      <div className="yt-comment-body">
                        <div className="yt-comment-meta">
                          <span className="yt-author">{replyName}</span>
                          <span className="yt-role-badge">
                            {reply.senderRole}
                          </span>
                          <span className="yt-dot">·</span>
                          <span className="yt-timestamp">{reply.date}</span>
                        </div>
                        <p className="yt-comment-text">{reply.messageText}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const handleSaveFeedback = async () => {
    if (!feedback || feedback.trim() === "") {
      console.warn("Feedback text is empty");
      return;
    }

    try {
      setSavingFeedback(true);
      const senderInfo = getSenderInfo();
      if (!senderInfo) {
        console.error("Unable to get sender info");
        setSavingFeedback(false);
        return;
      }

      const receiverUserId =
        selectedAgent && selectedAgent.value
          ? parseInt(extractAgentId(selectedAgent.value))
          : null;

      const payload = {
        senderUserId: senderInfo.senderUserId,
        receiverUserId: receiverUserId,
        messageText: feedback.trim(),
        senderName: senderInfo.senderName
          ? senderInfo.senderName.replace(/\bnull\b/gi, "").trim()
          : "",
        senderRole: senderInfo.senderRole,
        isResponseExpected: responseExpectation === "yes",
        parentFeedbackId: null,
        threadId: null,
      };

      await postAgentFeedbackAPI(payload);

      setFeedback("");
      setResponseExpectation("yes");

      const loginState = localStorage.getItem("loginState");
      const loginData = JSON.parse(loginState);
      const userId = loginData?.data?.[0]?.AdminID;
      if (userId) {
        const agentId =
          userRole != "Agent" && selectedAgent
            ? selectedAgent.value.replace(/\D/g, "")
            : null;
        const response = await getAgentFeedbackAPI(userId, agentId);
        if (response && Array.isArray(response)) {
          const transformedData = response.map((item) => ({
            feedbackId: item.FeedbackId,
            threadId: item.ThreadId,
            createdAt: item.CreatedAt,
            date: formatDateTimeEST(item.CreatedAt),
            senderName: item.SenderName || "Unknown",
            senderUserId: item.SenderUserId,
            receiverUserId: item.ReceiverUserId,
            messageText: item.MessageText,
            isResponseExpected: item.IsResponseExpected,
            senderRole: item.SenderRole || "Unknown",
            isActive: item.IsActive === "Y",
            parentFeedbackId: item.ParentFeedbackId,
          }));
          setHistoryData(transformedData);
        }
      }
    } catch (err) {
      console.error("Error saving feedback:", err);
    } finally {
      setSavingFeedback(false);
    }
  };

  if (!isOpen && !showModalBasedOnNotification) return null;

  return (
    <div className="crs-popup-overlay">
      <div className="crs-popup-content enhanced">
        <div className="crs-popup-header">
          <h3 className="crs-main-title">Feedback</h3>
          <button
            className="crs-close-btn"
            onClick={handleModalClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="crs-body">

  <div
  className={`observation-input-container ${
    userRole === "Agent" ? "disabled-section" : ""
  }`}
>
  <label className="obs-label-text">Add Feedback:</label>

  <textarea
    className="crs-feedback-input"
    placeholder={
      userRole === "Agent"
        ? "Feedback is disabled "
        : "Write your feedback here..."
    }
    value={feedback}
    onChange={(e) => setFeedback(e.target.value)}
    disabled={userRole === "Agent"}
  />
</div>

   { userRole !== "Agent" &&       <div className="crs-response-segment crs-response-segment--between">
            <span className="segment-label">Response Expectation</span>
            <div className="segment-control">
              <button
                className={`segment-btn ${responseExpectation === "yes" ? "active" : ""}`}
                onClick={() => setResponseExpectation("yes")}
              >
                Yes
              </button>
              <button
                className={`segment-btn ${responseExpectation === "no" ? "active" : ""}`}
                onClick={() => setResponseExpectation("no")}
              >
                No
              </button>
            </div>
          </div>
          }

          <div className="crs-block">
            <div className="crs-block-title">Feedback History</div>

            {loading && (
              <div className="crs-history-container">
                <p style={{ textAlign: "center", color: "#666" }}>
                  Loading feedback...
                </p>
              </div>
            )}

            {error && (
              <div className="crs-history-container">
                <p style={{ textAlign: "center", color: "#d9534f" }}>
                  Error: {error}
                </p>
              </div>
            )}

            {!loading && !error && historyData.length === 0 && (
              <div className="crs-history-container">
                <p style={{ textAlign: "center", color: "#666" }}>
                  No feedback history available.
                </p>
              </div>
            )}

            {!loading && !error && historyData.length > 0 && (
              <div className="crs-history-container">
                {threads.map((thread) => renderThread(thread))}
              </div>
            )}
          </div>
        </div>

        {/* FOOTER */}
        <div className="crs-footer">
          <button
            className="crs-btn-secondary"
            onClick={handleModalClose}
            disabled={savingFeedback}
          >
            Cancel
          </button>
          <button
            className="crs-btn-primary"
            onClick={handleSaveFeedback}
            disabled={savingFeedback || !feedback.trim()}
          >
            {savingFeedback ? (
              <>
                <span className="crs-loader"></span>
                Saving...
              </>
            ) : (
              "Save Feedback"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentFeedbackModal;
